module.exports = __webpack_public_path__ + "img/appointment.c5aff471.png";